var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('IconButton',{staticClass:"header__back",class:{ header__back_hidden: _vm.isBackHidden },attrs:{"icon":"back","view":"outlined","theme":"dim"},on:{"click":function($event){return _vm.$emit('back')}}}),_c('Logo',{staticClass:"header__logo",class:{ header__logo_hidden: _vm.isLogoHidden }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }